import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';

import { PuntoVisita } from '../Models/PuntoVisita';

@Injectable()
export class ReportePuntoVisitaService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }


  /**
   * Obtengo una lista de punto de visita para el reporte de puntos de visita
   * @param compania Codigo de la compañia
   * @param idZona Codigo de la zona
   * @param idRuta Codigo de la ruta
   */
  ObtenerReportePuntosVisita(compania: string, idZona: number, idRuta: number): Observable<PuntoVisita[]> {

    try {

      let url = this._utiles.getURL("reportepuntovisita/reportepuntovisita/" + compania + '/' + idZona + '/' + idRuta);


      return this._http.get(url).map((response: Response) => {
        return <PuntoVisita[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


}
